import { fallbackAutoGenerated } from './generated.fallbackAutoGenerated'

export const autoGeneratedDk: Record<
  keyof typeof fallbackAutoGenerated,
  string
> = {
  ...fallbackAutoGenerated,
  'moneyIn.voucher.Afvigelse.title': 'Afvigelse',
  'moneyIn.voucher.AggregatedPersonSpecVoucher.title':
    'Aggregeret personspecifikationsbilag',
  'moneyIn.voucher.AmountWithPeriod.title': 'Beløb med periode',
  'moneyIn.voucher.AssumedMoneyInPolicySpecification.title':
    'Forventet indbetalingsspecifikation for police',
  'moneyIn.voucher.AssumedPaymentInvoiceElementVoucher.title':
    'Bilag for forventet betaling af fakturalinje',
  'moneyIn.voucher.AssumedPaymentInvoiceSpecification.title':
    'Fakturaspecifikation for forventet betaling',
  'moneyIn.voucher.AzlPreliminaryPremiumVoucher.title':
    'AZL-bilag for foreløbig præmie',
  'moneyIn.voucher.AzlReturnPaymentInvoiceSpecification.title':
    'AZL-fakturaspecifikation for tilbagebetaling',
  'moneyIn.voucher.AzlReturnPaymentInvoiceVoucher.title':
    'AZL-fakturabilag for tilbagebetaling',
  'moneyIn.voucher.BeskGrad.title': 'Beskæftigelsesgrad',
  'moneyIn.voucher.BillingPaymentSpecVoucher.title':
    'Specifikationsbilag for opkrævningsbetaling',
  'moneyIn.voucher.BillingRequestInvoiceSpecification.title':
    'Fakturaspecifikation for opkrævningsanmodning',
  'moneyIn.voucher.BillingRequestSpecification.title':
    'Opkrævningsspecifikation',
  'moneyIn.voucher.BillingRequestVoucher.title':
    'Bilag for opkrævningsanmodning',
  'moneyIn.voucher.BillingVoucher.title': 'Opkrævningsbilag',
  'moneyIn.voucher.BlobRef.title': 'Blobreference',
  'moneyIn.voucher.Bs601BillingVoucher.title': 'BS601-opkrævningsbilag',
  'moneyIn.voucher.Bs602BillingPaymentSpecVoucher.title':
    'BS602-specifikationsbilag for opkrævningsbetaling',
  'moneyIn.voucher.Bs602PaymentVoucher.title': 'BS602-betalingsbilag',
  'moneyIn.voucher.CancelledBillingRequestVoucher.title':
    'Bilag for annulleret opkrævningsanmodning',
  'moneyIn.voucher.CancelledInvoicePaymentVoucher.title':
    'Bilag for annulleret fakturabetaling',
  'moneyIn.voucher.CommonEmploymentInformation.title':
    'Fælles ansættelsesoplysninger',
  'moneyIn.voucher.CompanyRef.title': 'Virksomhedsreference',
  'moneyIn.voucher.CorporatePaymentOrigin.title':
    'Oprindelse af virksomhedsbetaling',
  'moneyIn.voucher.CorporatePersonSpec.title':
    'Virksomhedens personspecifikation',
  'moneyIn.voucher.CorporateSpecSourceInformation.title':
    'Kildeoplysninger for arbejdsgivers specifikation',
  'moneyIn.voucher.CorporateSpecificationLineVoucher.title':
    'Bilag for virksomhedens specifikationslinje',
  'moneyIn.voucher.DailyWage.title': 'Dagløn',
  'moneyIn.voucher.DirectDebitPaymentCancellationVoucher.title':
    'Bilag for annulleret betaling ved direkte debitering',
  'moneyIn.voucher.DirectDebitPaymentSpecVoucher.title':
    'Betalingsspecifikationsbilag for direkte debitering',
  'moneyIn.voucher.DirectDebitPaymentVoucher.title':
    'Betalingsbilag for direkte debitering',
  'moneyIn.voucher.DocumentRef.title': 'Dokumentreference',
  'moneyIn.voucher.EfakturaPaymentVoucher.title': 'E-faktura-betalingsbilag',
  'moneyIn.voucher.EmployeeData.title': 'Medarbejderoplysninger',
  'moneyIn.voucher.EmployeePremiumVoucher.title': 'Medarbejderpræmiebilag',
  'moneyIn.voucher.EmployerAgreementData.title': 'Firmaaftaledata',
  'moneyIn.voucher.EmployerInvoiceSpecification.title':
    'Arbejdsgivers fakturaspecifikation',
  'moneyIn.voucher.EmployerSpecVoucher.title':
    'Arbejdsgiverspecifikationsbilag',
  'moneyIn.voucher.EmploymentContributionSpec.title':
    'Specifikation af ansættelsesbidrag',
  'moneyIn.voucher.EmploymentData.title': 'Ansættelsesoplysninger',
  'moneyIn.voucher.EmploymentDataCancellation.title':
    'Annullering af ansættelsesoplysninger',
  'moneyIn.voucher.EmploymentDataCancellationVoucher.title':
    'Bilag for annullering af ansættelsesoplysninger',
  'moneyIn.voucher.EmploymentVoucher.title': 'Ansættelsesbilag',
  'moneyIn.voucher.ExternalInvoiceElementVoucher.title':
    'Eksternt fakturalinjebilag',
  'moneyIn.voucher.ExternalInvoiceSpecification.title':
    'Ekstern fakturaspecifikation',
  'moneyIn.voucher.ExternalPayloadOrigin.title':
    'Oprindelse af eksterne indholdsdata',
  'moneyIn.voucher.ExternalPayloadSourceData.title':
    'Kildedata for eksterne indholdsdata',
  'moneyIn.voucher.ExternalPaymentLineData.title':
    'Eksterne betalingslinjedata',
  'moneyIn.voucher.IN00500Line.title': 'IN00500-linje',
  'moneyIn.voucher.IncomingValueTransferPaymentVoucher.title':
    'Betalingsbilag for indgående værdioverførsel',
  'moneyIn.voucher.IncomingValueTransferVoucher.title':
    'Bilag for indgående værdioverførsel',
  'moneyIn.voucher.InfoServiceFileMetrics.title': 'InfoService-filstatistik',
  'moneyIn.voucher.InfoServiceLineVoucher.title': 'InfoService-linjebilag',
  'moneyIn.voucher.InfoServicePaymentVoucher.title':
    'InfoService-betalingsbilag',
  'moneyIn.voucher.InfoserviceCorporateSpec.title':
    'InfoService-virksomhedsspecifikation',
  'moneyIn.voucher.InstallmentPlanInvoiceElementVoucher.title':
    'Fakturalinjebilag for afdragsordning',
  'moneyIn.voucher.InstallmentPlanInvoiceReference.title':
    'Fakturareference for afdragsordning',
  'moneyIn.voucher.InstallmentPlanInvoiceSpecification.title':
    'Fakturaspecifikation for afdragsordning',
  'moneyIn.voucher.InvoiceBundlingPenaltyVoucher.title':
    'Bilag for gebyr ved fakturasamling',
  'moneyIn.voucher.InvoiceElementVoucher.title': 'Fakturalinjebilag',
  'moneyIn.voucher.InvoicePaymentOrigin.title': 'Oprindelse af fakturabetaling',
  'moneyIn.voucher.InvoicePaymentVoucher.title': 'Fakturabetalingsbilag',
  'moneyIn.voucher.InvoicePenaltyVoucher.title': 'Fakturagebyrbilag',
  'moneyIn.voucher.InvoiceSpecification.title': 'Fakturaspecifikation',
  'moneyIn.voucher.LeaveInformation.title': 'Orlovsoplysninger',
  'moneyIn.voucher.LegalEntityRef.title': 'Reference til juridisk enhed',
  'moneyIn.voucher.ManualExternalInvoiceElementVoucher.title':
    'Manuelt eksternt fakturalinjebilag',
  'moneyIn.voucher.ManualInvoice.title': 'Manuel faktura',
  'moneyIn.voucher.ManualInvoiceDetail.title': 'Manuel fakturalinje',
  'moneyIn.voucher.ManualInvoiceSpecification.title':
    'Manuel fakturaspecifikation',
  'moneyIn.voucher.ManualPaymentSpecOrigin.title':
    'Oprindelse af manuel betalingsspecifikation',
  'moneyIn.voucher.ManualPaymentVoucher.title': 'Manuelt betalingsbilag',
  'moneyIn.voucher.MigratedInvoice.title': 'Migreret faktura',
  'moneyIn.voucher.MigratedInvoiceSpecification.title':
    'Migreret fakturaspecifikation',
  'moneyIn.voucher.MoneyInVoucher.title': 'Indbetalingsbilag',
  'moneyIn.voucher.NaturalPerson.title': 'Fysisk person',
  'moneyIn.voucher.NetAxeptBatch.title': 'NetAxept-batch',
  'moneyIn.voucher.NetAxeptBatchData.title': 'NetAxept-batchdata',
  'moneyIn.voucher.NetAxeptPaymentVoucher.title': 'NetAxept-betalingsbilag',
  'moneyIn.voucher.NetAxeptVoucher.title': 'NetAxept-bilag',
  'moneyIn.voucher.NlBillingVoucher.title': 'Nederlandsk opkrævningsbilag',
  'moneyIn.voucher.NlValueTransferStatement.title':
    'Nederlandsk værdioverførselsopgørelse',
  'moneyIn.voucher.NormBidrag.title': 'Normbidrag',
  'moneyIn.voucher.OutgoingBillingSpecification.title':
    'Udgående opkrævningsspecifikation',
  'moneyIn.voucher.P41AmountEntity.title': 'P41-beløbsenhed',
  'moneyIn.voucher.P41BankAccount.title': 'P41-bankkonto',
  'moneyIn.voucher.P41BankAdditionalPaymentInfo.title':
    'P41-supplerende betalingsoplysninger fra bank',
  'moneyIn.voucher.P41BankDataCommon.title': 'P41-fælles bankdata',
  'moneyIn.voucher.P41BankPALTax31.title': 'P41-bankens PAL-skat 31',
  'moneyIn.voucher.P41BankPALTax32.title': 'P41-bankens PAL-skat 32',
  'moneyIn.voucher.P41BankPALTax33.title': 'P41-bankens PAL-skat 33',
  'moneyIn.voucher.P41BankPALTax34.title': 'P41-bankens PAL-skat 34',
  'moneyIn.voucher.P41BankPaymentInformation.title':
    'P41-bankbetalingsoplysninger',
  'moneyIn.voucher.P41BankPaymentRemark.title': 'P41-bankbetalingsbemærkning',
  'moneyIn.voucher.P41BankTransferData.title': 'P41-bankoverførselsdata',
  'moneyIn.voucher.P41BankTransferData34.title': 'P41-bankoverførselsdata 34',
  'moneyIn.voucher.P41BankTransferFromBankV2_3.title':
    'P41-overførsel fra bank (v2.3)',
  'moneyIn.voucher.P41BankTransferFromBankWithTax1V2_3.title':
    'P41-overførsel fra bank med skat 1 (v2.3)',
  'moneyIn.voucher.P41BankTransferFromPensionV2_3.title':
    'P41-overførsel fra pension (v2.3)',
  'moneyIn.voucher.P41BankTransferFromPensionWithTax1V2_3.title':
    'P41-overførsel fra pension med skat 1 (v2.3)',
  'moneyIn.voucher.P41BankTransferV2_3.title': 'P41-bankoverførsel (v2.3)',
  'moneyIn.voucher.P41ContactPerson.title': 'P41-kontaktperson',
  'moneyIn.voucher.P41EmbeddedDocument.title': 'P41-indlejret dokument',
  'moneyIn.voucher.P41OngoingAgeSchemePayments.title':
    'P41-løbende betalinger til aldersopsparing',
  'moneyIn.voucher.P41OngoingInstalmentPensionPayments.title':
    'P41-løbende betalinger til ratepension',
  'moneyIn.voucher.P41OngoingLifetimeAnnuityPayments.title':
    'P41-løbende betalinger til livsvarig livrente',
  'moneyIn.voucher.P41OngoingPaymentsType.title':
    'P41-type af løbende betalinger',
  'moneyIn.voucher.P41OngoingStoppingAnnuityPayments.title':
    'P41-løbende betalinger til ophørende livrente',
  'moneyIn.voucher.P41PaymentAgeType.title': 'P41-type af udbetalingsalder',
  'moneyIn.voucher.P41PaymentInformation.title': 'P41-betalingsoplysninger',
  'moneyIn.voucher.P41PaymentSpecVoucher.title':
    'P41-betalingsspecifikationsbilag',
  'moneyIn.voucher.P41PaymentVoucher.title': 'P41-betalingsbilag',
  'moneyIn.voucher.P41PensionPALTax.title': 'P41-pensionens PAL-skat',
  'moneyIn.voucher.P41PensionPaymentInformation.title':
    'P41-pensionsbetalingsoplysninger',
  'moneyIn.voucher.P41PensionPrivateTransferV3_5.title':
    'P41-privat pensionsoverførsel (v3.5)',
  'moneyIn.voucher.P41PensionProfessionalTransferV3_5.title':
    'P41-erhvervsmæssig pensionsoverførsel (v3.5)',
  'moneyIn.voucher.P41PensionTransferV3_5.title':
    'P41-pensionsoverførsel (v3.5)',
  'moneyIn.voucher.P41Repurchase.title': 'P41-tilbagekøb',
  'moneyIn.voucher.P41SpousePension.title': 'P41-ægtefællepension',
  'moneyIn.voucher.P41SuppAmountEntity.title': 'P41-supplerende beløbsenhed',
  'moneyIn.voucher.P41ToBankV2_3.title': 'P41-overførsel til bank (v2.3)',
  'moneyIn.voucher.P41Transfer.title': 'P41-overførsel',
  'moneyIn.voucher.P41TrivialityAdjustmentVoucher.title':
    'P41-bilag for bagatelregulering',
  'moneyIn.voucher.PaidInvoiceVoucher.title': 'Bilag for betalt faktura',
  'moneyIn.voucher.PartIdentification.title': 'Delidentifikation',
  'moneyIn.voucher.PaymentOrigin.title': 'Betalingens oprindelse',
  'moneyIn.voucher.PaymentSender.title': 'Betalingsafsender',
  'moneyIn.voucher.PaymentSpecOrigin.title':
    'Betalingsspecifikationens oprindelse',
  'moneyIn.voucher.PaymentSpecSubVoucher.title':
    'Underbilag for betalingsspecifikation',
  'moneyIn.voucher.PaymentSpecVoucher.title': 'Betalingsspecifikationsbilag',
  'moneyIn.voucher.PaymentVoucher.title': 'Betalingsbilag',
  'moneyIn.voucher.PenaltyVoucher.title': 'Gebyrbilag',
  'moneyIn.voucher.PensionProviderPaymentOrigin.title':
    'Oprindelse af pensionsudbyderbetaling',
  'moneyIn.voucher.PensionTransferVoucher.title': 'Pensionsoverførselsbilag',
  'moneyIn.voucher.PersonRef.title': 'Personreference',
  'moneyIn.voucher.PersonSpecVoucher.title': 'Personspecifikationsbilag',
  'moneyIn.voucher.PremiumCalculationPenaltyVoucher.title':
    'Gebyrbilag for præmieberegning',
  'moneyIn.voucher.PremiumExternalInvoiceElementVoucher.title':
    'Eksternt præmiefakturalinjebilag',
  'moneyIn.voucher.PremiumInvoiceDetail.title': 'Præmiefakturalinje',
  'moneyIn.voucher.PrivateBillingInvoiceElementVoucher.title':
    'Fakturalinjebilag for privat opkrævning',
  'moneyIn.voucher.PrivatePaidBillingVoucher.title':
    'Bilag for betalt privat opkrævning',
  'moneyIn.voucher.PrivatePaymentOrigin.title': 'Oprindelse af privat betaling',
  'moneyIn.voucher.ReminderFeeVoucher.title': 'Rykkergebyrbilag',
  'moneyIn.voucher.ReturnedPaymentVoucher.title':
    'Bilag for returneret betaling',
  'moneyIn.voucher.SalaryInformation.title': 'Lønoplysninger',
  'moneyIn.voucher.SenderAccount.title': 'Afsenderkonto',
  'moneyIn.voucher.SenderAccountIban.title': 'Afsenderkonto (IBAN)',
  'moneyIn.voucher.SenderAccountOther.title': 'Anden afsenderkonto',
  'moneyIn.voucher.TelephoneNumber.title': 'Telefonnummer',
  'moneyIn.voucher.TransitContributionOutVoucher.title':
    'Bilag for udgående transitbidrag',
  'moneyIn.voucher.TransitCorporateSpecificationLineVoucher.title':
    'Transitbilag for virksomhedens specifikationslinje',
  'moneyIn.voucher.TwkInvoice.title': 'TWK-faktura',
  'moneyIn.voucher.TwkInvoiceSpecification.title': 'TWK-fakturaspecifikation',
  'moneyIn.voucher.UnexpectedDistributedInvoicePaymentVoucher.title':
    'Bilag for uventet fordelt fakturabetaling',
  'moneyIn.voucher.UnexpectedInvoicePaymentVoucher.title':
    'Bilag for uventet fakturabetaling',
  'moneyIn.voucher.UnexpectedPaymentVoucher.title':
    'Bilag for uventet betaling',
  'moneyIn.voucher.UnrelatedPaymentVoucher.title':
    'Bilag for betaling uden tilknytning',
  'moneyIn.voucher.UpaIncomeRelation.title': 'UPA-indkomstforhold',
  'moneyIn.voucher.UpaIncomeRelationDeclarationValidationResult.title':
    'Valideringsresultat for UPA-indkomstindberetning',
  'moneyIn.voucher.UpaIncomeRelationDeclarationValidationResultV2.title':
    'Valideringsresultat for UPA-indkomstindberetning (v2)',
  'moneyIn.voucher.UpaIncomeRelationVoucher.title': 'UPA-indkomstforholdsbilag',
  'moneyIn.voucher.UpaIncomeRelationVoucherV2.title':
    'UPA-indkomstforholdsbilag (v2)',
  'moneyIn.voucher.UpaIncomeRelationWithdrawalVoucher.title':
    'Bilag for tilbagetrækning af UPA-indkomstforhold',
  'moneyIn.voucher.UpaIncomeRelationWithdrawalVoucherV2.title':
    'Bilag for tilbagetrækning af UPA-indkomstforhold (v2)',
  'moneyIn.voucher.UpaMessageValidationResult.title':
    'Valideringsresultat for UPA-meddelelse',
  'moneyIn.voucher.UpaMessageValidationResultV2.title':
    'Valideringsresultat for UPA-meddelelse (v2)',
  'moneyIn.voucher.UpaValidationVoucher.title': 'UPA-valideringsbilag',
  'moneyIn.voucher.UpaVoucher.title': 'UPA-bilag',
  'moneyIn.voucher.UpaVoucherV2.title': 'UPA-bilag (v2)',
  'moneyIn.voucher.ValueTransferAutomaticPaymentVoucher.title':
    'Bilag for automatisk betaling ved værdioverførsel',
  'moneyIn.voucher.ValueTransferStatement.title': 'Værdioverførselsopgørelse',
  'moneyIn.voucher.VoluntaryContributionVoucher.title':
    'Bilag for frivilligt bidrag',
  'moneyIn.voucher.WithdrawnContributionVoucher.title':
    'Bilag for tilbagetrukket bidrag',
  'moneyIn.voucher.WriteOffInvoicePaymentVoucher.title':
    'Bilag for afskrevet fakturabetaling',
  'moneyIn.voucher._id': 'ID',
  'moneyIn.voucher.absoluteAmount': 'Absolut beløb',
  'moneyIn.voucher.accountNumber': 'Kontonummer',
  'moneyIn.voucher.accruedRightHolidayAllowance': 'Optjent ret til ferietillæg',
  'moneyIn.voucher.acqRefDataVar': 'Variabel reference fra kortindløser',
  'moneyIn.voucher.additionalInformation': 'Supplerende oplysninger',
  'moneyIn.voucher.additionalPaymentInfo': 'Supplerende betalingsoplysninger',
  'moneyIn.voucher.advNo': 'ADV-nr.',
  'moneyIn.voucher.afsAftNrHosModt': 'Afsenders aftalenummer hos modtager',
  'moneyIn.voucher.afvigelse': 'Afvigelse',
  'moneyIn.voucher.afvigelseDto': 'Afvigelsesdato',
  'moneyIn.voucher.afvigelseKod': 'Afvigelseskode',
  'moneyIn.voucher.afvigelsesBlb': 'Afvigelsesbeløb',
  'moneyIn.voucher.afvigelsesFrtflt': 'Afvigelse (Frtflt)',
  'moneyIn.voucher.afvigelsesPct': 'Afvigelsesprocent',
  'moneyIn.voucher.aggregationLineId': 'Aggregeringslinje-ID',
  'moneyIn.voucher.agreementId': 'Firmaaftale-ID',
  'moneyIn.voucher.agreementQualifier': 'Aftaleform',
  'moneyIn.voucher.amount': 'Beløb',
  'moneyIn.voucher.amountEntity': 'Beløbsenhed',
  'moneyIn.voucher.amountOriginal': 'Oprindeligt beløb',
  'moneyIn.voucher.amountPenalties': 'Gebyrbeløb',
  'moneyIn.voucher.amountPenaltiesTwk': 'TWK-gebyrbeløb',
  'moneyIn.voucher.amountRegularPremium': 'Ordinært præmiebeløb',
  'moneyIn.voucher.amountSettlement': 'Afregningsbeløb',
  'moneyIn.voucher.amountTwkPremium': 'TWK-præmiebeløb',
  'moneyIn.voucher.arbAndelBidragBlb': 'Arbejdsgiverandel af bidrag',
  'moneyIn.voucher.arbAndelPensBidragPct':
    'Arbejdsgiverandel af pensionsbidrag (%)',
  'moneyIn.voucher.args': 'Argumenter',
  'moneyIn.voucher.assetManagementCost': 'Kapitalforvaltningsomkostninger',
  'moneyIn.voucher.assetManagementCostOngoingAgeScheme_Bank':
    'Kapitalforvaltningsomkostninger, løbende aldersopsparing (bank)',
  'moneyIn.voucher.assetManagementCostTaxCode1B_Bank':
    'Kapitalforvaltningsomkostninger, skattekode 1B (bank)',
  'moneyIn.voucher.assetManagementCostTaxCode1and2_Bank':
    'Kapitalforvaltningsomkostninger, skattekode 1 og 2 (bank)',
  'moneyIn.voucher.assetManagementCostTaxCode2B_Bank':
    'Kapitalforvaltningsomkostninger, skattekode 2B (bank)',
  'moneyIn.voucher.assetManagementCostTaxCode3A_Bank':
    'Kapitalforvaltningsomkostninger, skattekode 3A (bank)',
  'moneyIn.voucher.assetManagementCostTaxCode3B_Bank':
    'Kapitalforvaltningsomkostninger, skattekode 3B (bank)',
  'moneyIn.voucher.assetManagementCostTaxfreeAgeScheme_Bank':
    'Kapitalforvaltningsomkostninger, skattefri aldersopsparing (bank)',
  'moneyIn.voucher.assumedMoneyInCoverSpecifications':
    'Forventede indbetalingsspecifikationer for dækninger',
  'moneyIn.voucher.assumedMoneyInId': 'Forventet indbetaling-ID',
  'moneyIn.voucher.assumedMoneyInPolicySpecification':
    'Forventet indbetalingsspecifikation for police',
  'moneyIn.voucher.assumedPaymentInvoiceSpecificationEntries':
    'Specifikationslinjer for forventede fakturabetalinger',
  'moneyIn.voucher.attachedTaxExemption': 'Vedlagt skattefritagelse',
  'moneyIn.voucher.availStatementFromEmployerWithId':
    'Tilgængelig arbejdsgiveropgørelse med ID',
  'moneyIn.voucher.bankAccountKind': 'Bankkontotype',
  'moneyIn.voucher.bankRegistrationNumber': 'Registreringsnummer',
  'moneyIn.voucher.baseAmount': 'Grundbeløb',
  'moneyIn.voucher.baseInvoiceId': 'Grundfaktura-ID',
  'moneyIn.voucher.batchData': 'Batchdata',
  'moneyIn.voucher.batchId': 'Batch-ID',
  'moneyIn.voucher.batchNumber': 'Batchnummer',
  'moneyIn.voucher.batchPaymentId': 'Batchbetaling-ID',
  'moneyIn.voucher.beskGrad': 'BeskGrad',
  'moneyIn.voucher.beskGradAnt': 'BeskGrad (Ant)',
  'moneyIn.voucher.beskGradNvn': 'BeskGrad (navn)',
  'moneyIn.voucher.beskGradStartDto': 'BeskGrad (startdato)',
  'moneyIn.voucher.beskGradTel': 'BeskGrad (Tel)',
  'moneyIn.voucher.billingChannel': 'Betalingskanal',
  'moneyIn.voucher.billingFrequency': 'Betalingsfrekvens',
  'moneyIn.voucher.billingLegalEntityId': 'Opkrævet juridisk enhed-ID',
  'moneyIn.voucher.billingRequestEntries': 'Opkrævningslinjer',
  'moneyIn.voucher.billingRequestId': 'Opkrævningsanmodning-ID',
  'moneyIn.voucher.billingRequestSpecification': 'Opkrævningsspecifikation',
  'moneyIn.voucher.billingRequestSpecifications': 'Opkrævningsspecifikationer',
  'moneyIn.voucher.billingText': 'Opkrævningstekst',
  'moneyIn.voucher.billingVoucher': 'Opkrævningsbilag',
  'moneyIn.voucher.birthDate': 'Fødselsdato',
  'moneyIn.voucher.blanks': 'Tomme felter',
  'moneyIn.voucher.blobName': 'Blobnavn',
  'moneyIn.voucher.blobRef': 'Blobreference',
  'moneyIn.voucher.blockedInMoneyIn': 'Blokeret i MoneyIn',
  'moneyIn.voucher.bookDate': 'Bogføringsdato',
  'moneyIn.voucher.bs602BillingType': 'BS602-opkrævningstype',
  'moneyIn.voucher.buildUpEmploymentTermsAmount':
    'Optjent beløb fra ansættelsesvilkår',
  'moneyIn.voucher.bundleDueDate': 'Samlet forfaldsdato',
  'moneyIn.voucher.bundlePeriodFromDate': 'Startdato for samlingsperiode',
  'moneyIn.voucher.calculationDate': 'Beregningsdato',
  'moneyIn.voucher.cancellationDate': 'Annulleringsdato',
  'moneyIn.voucher.cancellationPaymentId': 'Annulleringsbetaling-ID',
  'moneyIn.voucher.cancellationReason': 'Årsag',
  'moneyIn.voucher.cancellations': 'Annulleringer',
  'moneyIn.voucher.cardAcptTermId': 'Kortterminal-ID',
  'moneyIn.voucher.cardNameLogo': 'Kortnavn og logo',
  'moneyIn.voucher.cardOrganisation': 'Kortudbyder',
  'moneyIn.voucher.caseNo': 'Sagsnummer',
  'moneyIn.voucher.category': 'Kategori',
  'moneyIn.voucher.cedingCompany': 'CVR',
  'moneyIn.voucher.changeDate': 'Ændringsdato',
  'moneyIn.voucher.code': 'Kode',
  'moneyIn.voucher.codeCollectiveWorkAgreement': 'Overenskomstkode',
  'moneyIn.voucher.codeIncidentalIncomeReduction':
    'Kode for midlertidig indkomstreduktion',
  'moneyIn.voucher.codeIncomeRelationType': 'Kode for indkomstforholdstype',
  'moneyIn.voucher.codeInfluenceInsuranceObligation':
    'Kode for påvirkning af forsikringspligt',
  'moneyIn.voucher.codeLeaveType': 'Kode for orlovstype',
  'moneyIn.voucher.codeNatureOfEmploymentRelationship':
    'AnsættelsesforholdsKode',
  'moneyIn.voucher.codePhaseDivision': 'Kode for faseinddeling',
  'moneyIn.voucher.codeProfession': 'Stillingskode',
  'moneyIn.voucher.codeReasonForTerminationOfEmployment':
    'Kode for årsag til ansættelsesophør',
  'moneyIn.voucher.codeSpecialIncomeRatio': 'Kode for særligt indkomstforhold',
  'moneyIn.voucher.collectiveAgreement': 'Kollektiv aftale',
  'moneyIn.voucher.collectiveAgreementId': 'Kollektiv aftale-ID',
  'moneyIn.voucher.commission': 'Provision',
  'moneyIn.voucher.commitmentId': 'Engagement-ID',
  'moneyIn.voucher.commitmentOwner': 'Engagementsejer',
  'moneyIn.voucher.commitmentOwnerLegalEntityId':
    'Engagementsejers juridiske enhed-ID',
  'moneyIn.voucher.commonEmploymentInformation':
    'Fælles ansættelsesoplysninger',
  'moneyIn.voucher.companyId': 'Virksomheds-ID',
  'moneyIn.voucher.component': 'Komponent',
  'moneyIn.voucher.contactName': 'Kontaktperson',
  'moneyIn.voucher.contactPhoneNo': 'Kontakttelefonnummer',
  'moneyIn.voucher.contractHoursPerWeek': 'Aftalte timer pr. uge',
  'moneyIn.voucher.contributingElements': 'Bidragselementer',
  'moneyIn.voucher.contributionCode': 'Indbetalingskode',
  'moneyIn.voucher.contributionId': 'Bidrags-ID',
  'moneyIn.voucher.contributionOptionality': 'Frivillig/Obligatorisk',
  'moneyIn.voucher.contributionPartId': 'Bidragsdel-ID',
  'moneyIn.voucher.contributionParts': 'Bidragsdele',
  'moneyIn.voucher.contributionVouchersRefs': 'Referencer til bidragsbilag',
  'moneyIn.voucher.corporatePersonSpec': 'Personspecifikation fra arbejdsgiver',
  'moneyIn.voucher.corporateSpecSourceInformation':
    'Kildeoplysninger for arbejdsgivers specifikation',
  'moneyIn.voucher.corporateSpecificationLineVouchers':
    'Bilag for arbejdsgivers specifikationslinjer',
  'moneyIn.voucher.countingIndication': 'Optællingsindikator',
  'moneyIn.voucher.cover': 'Dækning',
  'moneyIn.voucher.coverDescription': 'Dækningsbeskrivelse',
  'moneyIn.voucher.coverInternalTemplateId': 'Internt dækningsskabelon-ID',
  'moneyIn.voucher.coverPeriodEnd': 'Dækningsperiodens slutdato',
  'moneyIn.voucher.coverPeriodStart': 'Dækningsperiodens startdato',
  'moneyIn.voucher.creationStamp': 'Oprettelses tidspunkt',
  'moneyIn.voucher.creationTime': 'Oprettelsestidspunkt',
  'moneyIn.voucher.creditPaymentIndicator': 'Kreditbetalingsindikator',
  'moneyIn.voucher.creditorName': 'Kreditornavn',
  'moneyIn.voucher.currency': 'Valuta',
  'moneyIn.voucher.currencyOriginal': 'Oprindelig valuta',
  'moneyIn.voucher.currencySettl': 'Afregningsvaluta',
  'moneyIn.voucher.custRefNo': 'Kundereferencenummer',
  'moneyIn.voucher.customerCPR': 'Kundens CPR-nummer',
  'moneyIn.voucher.dailyWage': 'Dagløn',
  'moneyIn.voucher.dateTimeTrn': 'Transaktionstidspunkt',
  'moneyIn.voucher.dateTimeUpaFileCreation':
    'Tidspunkt for oprettelse af UPA-fil',
  'moneyIn.voucher.dateTimeUpaFileReceival':
    'Tidspunkt for modtagelse af UPA-fil',
  'moneyIn.voucher.daysWorked': 'Arbejdsdage',
  'moneyIn.voucher.dbCrCard': 'Debet- eller kreditkort',
  'moneyIn.voucher.dbaName': 'DBA-navn',
  'moneyIn.voucher.dccAmount': 'DCC-beløb',
  'moneyIn.voucher.dccCurrency': 'DCC-valuta',
  'moneyIn.voucher.debtorAccountNumber': 'Debitors kontonummer',
  'moneyIn.voucher.debtorCustomerNo': 'Debitors kundenummer',
  'moneyIn.voucher.debtorName': 'Debitornavn',
  'moneyIn.voucher.declarationLineId': 'Indberetningslinje-ID',
  'moneyIn.voucher.declaredIncomeRelationIds':
    'Indberettede indkomstforholds-ID’er',
  'moneyIn.voucher.defaultReceivingCompanyId': 'Standard modtagende selskab-ID',
  'moneyIn.voucher.deliveryDate': 'Leveringsdato',
  'moneyIn.voucher.deliveryNumber': 'Leverancenummer',
  'moneyIn.voucher.description': 'Beskrivelse',
  'moneyIn.voucher.directDebitType': 'Type af direkte debitering',
  'moneyIn.voucher.disableSpecificValidations':
    'Deaktiver specifikke valideringer',
  'moneyIn.voucher.dlSeNr': 'DL SE-nr.',
  'moneyIn.voucher.docEncodedFileContent': 'Kodet dokumentindhold',
  'moneyIn.voucher.docFileSize': 'Dokumentets filstørrelse',
  'moneyIn.voucher.docFilename': 'Dokumentets filnavn',
  'moneyIn.voucher.docFilenameExtention': 'Dokumentets filtype',
  'moneyIn.voucher.docMimeType': 'Dokumentets MIME-type',
  'moneyIn.voucher.documentFunction': 'Dokumentfunktion',
  'moneyIn.voucher.dueDate': 'Forfaldsdato',
  'moneyIn.voucher.earliestRetirementAge': 'Tidligste pensionsalder',
  'moneyIn.voucher.ediReference': 'EDI-reference',
  'moneyIn.voucher.employeeContributionMandatory':
    'Obligatorisk medarbejderbidrag',
  'moneyIn.voucher.employeeContributionOptional':
    'Frivilligt medarbejderbidrag',
  'moneyIn.voucher.employeeContributionOptionalWOPExemption':
    'Frivilligt medarbejderbidrag med WOP-fritagelse',
  'moneyIn.voucher.employeeData': 'Medarbejderoplysninger',
  'moneyIn.voucher.employeeId': 'Medarbejder-ID',
  'moneyIn.voucher.employerAgreementData': 'Arbejdsgiveraftaledata',
  'moneyIn.voucher.employerAgreementId': 'Firmaaftale-ID',
  'moneyIn.voucher.employerAgreementPolicyKey': 'Aftalepolice',
  'moneyIn.voucher.employerCertification': 'Arbejdsgiverattest',
  'moneyIn.voucher.employerContribution': 'Arbejdsgiverbidrag',
  'moneyIn.voucher.employerContributionPercentage':
    'Arbejdsgiverbidragsprocent',
  'moneyIn.voucher.employerId': 'Arbejdsgiver-CVR',
  'moneyIn.voucher.employerRef': 'Arbejdsgiverreference',
  'moneyIn.voucher.employerSpecId': 'Arbejdsgiverspecifikation-ID',
  'moneyIn.voucher.employingCompany': 'Arbejdsgiver',
  'moneyIn.voucher.employmentCancelled': 'Ansættelse annulleret',
  'moneyIn.voucher.employmentContractforIndefinitePeriod':
    'Tidsubegrænset ansættelseskontrakt',
  'moneyIn.voucher.employmentData': 'Ansættelsesoplysninger',
  'moneyIn.voucher.employmentDataCancellation':
    'Annullering af ansættelsesoplysninger',
  'moneyIn.voucher.employmentEnd': 'Ansættelsens slutdato',
  'moneyIn.voucher.employmentId': 'Ansættelsesforhold',
  'moneyIn.voucher.employmentName': 'Stillingsbetegnelse',
  'moneyIn.voucher.employmentStart': 'Ansættelsens startdato',
  'moneyIn.voucher.employmentType': 'Ansættelsestype',
  'moneyIn.voucher.endDate': 'Slutdato',
  'moneyIn.voucher.endToEndId': 'End-to-end-ID',
  'moneyIn.voucher.endingPension': 'Ophørende pension',
  'moneyIn.voucher.entryType': 'Posttype',
  'moneyIn.voucher.errorCodes': 'Fejlkoder',
  'moneyIn.voucher.errors': 'Fejl',
  'moneyIn.voucher.exPartnerValue': 'Værdi for tidligere partner',
  'moneyIn.voucher.externalEmploymentId': 'Eksternt ansættelses-ID',
  'moneyIn.voucher.externalPayloadKey': 'Ekstern datanøgle',
  'moneyIn.voucher.externalPayloadRegistrationRef':
    'Ekstern dataregistreringsreference',
  'moneyIn.voucher.externalPayloadSourceData': 'Kildedata for eksterne data',
  'moneyIn.voucher.externalPayloadType': 'Ekstern datatype',
  'moneyIn.voucher.externalPaymentId': 'Ekstern betaling-ID',
  'moneyIn.voucher.externalPaymentLineData': 'Eksterne betalingslinjedata',
  'moneyIn.voucher.externalRef': 'Ekstern reference',
  'moneyIn.voucher.externalTransferId': 'Eksternt overførsels-ID',
  'moneyIn.voucher.favourInformation': 'Begunstigelsesoplysninger',
  'moneyIn.voucher.fees': 'Gebyrer',
  'moneyIn.voucher.fkMedlemsNr': 'FK-medlemsnummer',
  'moneyIn.voucher.formerEmployer': 'Tidligere arbejdsgiver',
  'moneyIn.voucher.fromDate': 'Fra dato',
  'moneyIn.voucher.fromDueDate': 'Fra forfaldsdato',
  'moneyIn.voucher.fullSalaryInPeriod': 'Fuld løn i perioden',
  'moneyIn.voucher.generationScheme': 'Genereringsordning',
  'moneyIn.voucher.grossHourlyWage': 'Bruttotimeløn',
  'moneyIn.voucher.grossPayment': 'Bruttoydelse',
  'moneyIn.voucher.grossSalary': 'Løn',
  'moneyIn.voucher.handlingFee': 'Ekspeditionsgebyr',
  'moneyIn.voucher.holidayAllowance': 'Ferietillæg',
  'moneyIn.voucher.hoursOfLeave': 'Orlovstimer',
  'moneyIn.voucher.id': 'ID',
  'moneyIn.voucher.identityQualifier': 'Identitetskvalifikator',
  'moneyIn.voucher.identityValue': 'Identitetsværdi',
  'moneyIn.voucher.incomePeriods': 'Indkomstperioder',
  'moneyIn.voucher.incomeRelationEndDate': 'Indkomstforholdets slutdato',
  'moneyIn.voucher.incomeRelationId': 'Indkomstforholds-ID',
  'moneyIn.voucher.incomeRelationStartDate': 'Indkomstforholdets startdato',
  'moneyIn.voucher.incurredBundlingPenaltyIds':
    "ID'er for pålagte samlingsgebyrer",
  'moneyIn.voucher.indicationEndOfParticipation':
    'Indikator for deltagelsesophør',
  'moneyIn.voucher.infoServiceFileMetrics': 'InfoService-filstatistik',
  'moneyIn.voucher.infoType': 'Informationstype',
  'moneyIn.voucher.infotypeKod': 'Informationstypekode',
  'moneyIn.voucher.inputDate': 'Indlæsningsdato',
  'moneyIn.voucher.installmentPlanInvoiceReference':
    'Fakturareference for afdragsplan',
  'moneyIn.voucher.installmentPlanInvoiceReferences':
    'Fakturareferencer for afdragsplan',
  'moneyIn.voucher.installmentSpecifications': 'Afdragsspecifikationer',
  'moneyIn.voucher.insuredLegalEntityId': 'Forsikredes juridiske enheds-ID',
  'moneyIn.voucher.integrationName': 'Integrationsnavn',
  'moneyIn.voucher.interestAmount_Bank': 'Rentebeløb (bank)',
  'moneyIn.voucher.interestPeriodDaysCount': 'Antal dage i renteperioden',
  'moneyIn.voucher.interestRate': 'Rentesats',
  'moneyIn.voucher.interestStartDate': 'Rentestartdato',
  'moneyIn.voucher.interestStopDate': 'Renteslutdato',
  'moneyIn.voucher.internalReferenceToCustomerPolicy':
    'Intern reference til kundens police',
  'moneyIn.voucher.invoiceBundlingPenaltyType': 'Type af fakturasamlingsgebyr',
  'moneyIn.voucher.invoiceDate': 'Faktura dato',
  'moneyIn.voucher.invoiceDetails': 'Fakturalinjer',
  'moneyIn.voucher.invoiceId': 'Faktura-ID',
  'moneyIn.voucher.invoicePayerType': 'Fakturabetalertype',
  'moneyIn.voucher.invoicePeriodEndDate': 'Fakturaperiodens slutdato',
  'moneyIn.voucher.invoicePeriodStartDate': 'Fakturaperiodens startdato',
  'moneyIn.voucher.invoiceSourceRef': 'Fakturakildereference',
  'moneyIn.voucher.invoiceSpecification': 'Fakturaspecifikation',
  'moneyIn.voucher.invoiceStrategyOperationId':
    'Fakturastrategioperationens ID',
  'moneyIn.voucher.invoiceType': 'Fakturatype',
  'moneyIn.voucher.irregularitySurcharge': 'Uregelmæssighedstillæg',
  'moneyIn.voucher.isContributionAfterEmploymentEnd':
    'Bidrag efter ansættelsesophør',
  'moneyIn.voucher.isCustomerPALTaxPayer': 'Kunden er PAL-skattepligtig',
  'moneyIn.voucher.isManualTransfer': 'Manuel overførsel',
  'moneyIn.voucher.isPremiumAfterEmploymentEnd':
    'Præmie efter ansættelsesophør',
  'moneyIn.voucher.issuerCountry': 'Kortudsteders land',
  'moneyIn.voucher.jobAgreementRuleJoined': 'Tilsluttet ansættelsesaftaleregel',
  'moneyIn.voucher.jobDescription': 'Stillingsbeskrivelse',
  'moneyIn.voucher.keptWidowsPensionRight': 'Bevaret ret til enkepension',
  'moneyIn.voucher.key': 'Nøgle',
  'moneyIn.voucher.kundNrHosAfs': 'Kundenummer hos afsender',
  'moneyIn.voucher.kundNrHosModt': 'Kundenummer hos modtager',
  'moneyIn.voucher.kundStartDato': 'Kundens startdato',
  'moneyIn.voucher.labourAgreement': 'Overenskomst',
  'moneyIn.voucher.lastPayment': 'Seneste udbetaling',
  'moneyIn.voucher.latestContributionPaymentBegin':
    'Seneste bidragsbetalings startdato',
  'moneyIn.voucher.latestContributionPaymentEnd':
    'Seneste bidragsbetalings slutdato',
  'moneyIn.voucher.latestPayment': 'Seneste betaling',
  'moneyIn.voucher.leaveCoverage': 'Orlovsdækning',
  'moneyIn.voucher.leaveHoursInTimeSlot': 'Orlovstimer i tidsintervallet',
  'moneyIn.voucher.leaveInformation': 'Orlovsoplysninger',
  'moneyIn.voucher.leavePercentage': 'Orlovsprocent',
  'moneyIn.voucher.leaves': 'Orlovsperioder',
  'moneyIn.voucher.levDto': 'Leveringsdato',
  'moneyIn.voucher.levNr': 'Leverancenummer',
  'moneyIn.voucher.limitedWidowsPensionDate': 'Dato for begrænset enkepension',
  'moneyIn.voucher.lonTrinNr': 'Løntrinsnummer',
  'moneyIn.voucher.lonTrinStartDto': 'Løntrinnets startdato',
  'moneyIn.voucher.mandateId': 'Mandat-ID',
  'moneyIn.voucher.mandateIdentification': 'Mandatidentifikation',
  'moneyIn.voucher.mandateSignatureDate': 'Mandatets underskriftsdato',
  'moneyIn.voucher.manual': 'Manuel',
  'moneyIn.voucher.manualInvoice': 'Manuel faktura',
  'moneyIn.voucher.manualInvoiceDetail': 'Manuel fakturalinje',
  'moneyIn.voucher.manualInvoiceType': 'Manuel fakturatype',
  'moneyIn.voucher.maritalValue': 'Ægteskabsværdi',
  'moneyIn.voucher.merchantId': 'Forhandler-ID',
  'moneyIn.voucher.merchantNo': 'Forhandlernummer',
  'moneyIn.voucher.message': 'Meddelelse',
  'moneyIn.voucher.messageId': 'Meddelelses-ID',
  'moneyIn.voucher.messageReasonCodTxt': 'Meddelelsens årsagskodetekst',
  'moneyIn.voucher.messageText': 'Meddelelsestekst',
  'moneyIn.voucher.messageTypeId': 'Meddelelsestype-ID',
  'moneyIn.voucher.messageValidationResult':
    'Valideringsresultat for meddelelse',
  'moneyIn.voucher.migratedInvoice': 'Migreret faktura',
  'moneyIn.voucher.modtAfdNr': 'Modtagers afdelingsnummer',
  'moneyIn.voucher.modtPbsNr': 'Modtagers PBS-nummer',
  'moneyIn.voucher.multilangTxtShrt': 'Kort flersproget tekst',
  'moneyIn.voucher.naturalPerson': 'Fysisk person',
  'moneyIn.voucher.negativeUnusedPALTax': 'Uudnyttet negativ PAL-skat',
  'moneyIn.voucher.netAmountPaid': 'Betalt nettobeløb',
  'moneyIn.voucher.netAxeptBatch': 'NetAxept-batch',
  'moneyIn.voucher.netsTransId': 'Nets-transaktions-ID',
  'moneyIn.voucher.newSalaryDate': 'Dato for ny løn',
  'moneyIn.voucher.nlPremiumComponents': 'Præmiekomponenter',
  'moneyIn.voucher.nlValueTransferPartnerStatements':
    'Partneropgørelser for værdioverførsel',
  'moneyIn.voucher.noOfContributionsWithPeriodStartAtOrAfterPaymentDate':
    'Antal bidrag med periodestart på eller efter betalingsdato',
  'moneyIn.voucher.noOfContributionsWithPeriodStartBeforePaymentDate':
    'Antal bidrag med periodestart før betalingsdato',
  'moneyIn.voucher.noOfEmployerToEmployeeContributionBlocks':
    'Antal bidragsblokke fra arbejdsgiver til medarbejder',
  'moneyIn.voucher.noOfEmployers': 'Antal arbejdsgivere',
  'moneyIn.voucher.noOfRecords': 'Antal poster',
  'moneyIn.voucher.noOfRegulationsWithEarlyPeriodStart':
    'Antal reguleringer med tidlig periodestart',
  'moneyIn.voucher.nominalAnnualFullTimeSalary': 'Nominel årlig fuldtidsløn',
  'moneyIn.voucher.nominalPartTimePercentage': 'Nominel deltidsprocent',
  'moneyIn.voucher.normBidrag': 'Normbidrag',
  'moneyIn.voucher.normBidragBlb': 'Normbidragsbeløb',
  'moneyIn.voucher.normBidragStartDto': 'Normbidragets startdato',
  'moneyIn.voucher.normHoursInPeriod': 'Normtimer i perioden',
  'moneyIn.voucher.normHoursInPeriodLeave': 'Normtimer under orlov i perioden',
  'moneyIn.voucher.normHoursPerWeek': 'Normtimer pr. uge',
  'moneyIn.voucher.normHoursWeekly': 'Normtimer pr. uge',
  'moneyIn.voucher.numRecs': 'Antal poster',
  'moneyIn.voucher.numberOfInsured': 'Antal forsikrede',
  'moneyIn.voucher.numberOfPaidHours': 'Antal betalte timer',
  'moneyIn.voucher.numberOfTrans': 'Antal transaktioner',
  'moneyIn.voucher.numberOfUnits': 'Antal enheder',
  'moneyIn.voucher.onCallAgreementIndication': 'Indikator for tilkaldeaftale',
  'moneyIn.voucher.ongoingAgeScheme': 'Løbende aldersopsparing',
  'moneyIn.voucher.ongoingInstalmentPensionPayments':
    'Løbende ratepensionsudbetalinger',
  'moneyIn.voucher.ongoingStoppingAnnuityPayments':
    'Løbende udbetalinger fra ophørende livrente',
  'moneyIn.voucher.origDateTimeTrn': 'Oprindeligt transaktionstidspunkt',
  'moneyIn.voucher.originId': 'Oprindelses-ID',
  'moneyIn.voucher.originType': 'Oprindelsestype',
  'moneyIn.voucher.originVoucherRef': 'Reference til oprindelsesbilag',
  'moneyIn.voucher.originalAmount': 'Oprindeligt beløb',
  'moneyIn.voucher.originalDueDate': 'Oprindelig forfaldsdato',
  'moneyIn.voucher.originalPaymentDate': 'Oprindelig betalingsdato',
  'moneyIn.voucher.originalPostingId': 'Oprindeligt posterings-ID',
  'moneyIn.voucher.originalRef': 'Oprindelig reference',
  'moneyIn.voucher.outgoingBillingSpecification':
    'Udgående opkrævningsspecifikation',
  'moneyIn.voucher.outstandingAmount': 'Udestående beløb',
  'moneyIn.voucher.overenskomstnr': 'Overenskomstnummer',
  'moneyIn.voucher.ownedRecords': 'Ejede poster',
  'moneyIn.voucher.ownerId': 'Ejer-ID',
  'moneyIn.voucher.p41AmountItems': 'P41-beløbsposter',
  'moneyIn.voucher.p41BankAccount': 'P41-bankkonto',
  'moneyIn.voucher.p41BankDataCommon': 'P41-fælles bankdata',
  'moneyIn.voucher.p41BankPaymentInformation': 'P41-bankbetalingsoplysninger',
  'moneyIn.voucher.p41ContactPerson': 'P41-kontaktperson',
  'moneyIn.voucher.p41InterestCalculations': 'P41-renteberegninger',
  'moneyIn.voucher.p41OngoingAgeSchemePayments':
    'P41-løbende udbetalinger fra aldersopsparing',
  'moneyIn.voucher.p41OngoingInstalmentPensionPayments':
    'P41-løbende ratepensionsudbetalinger',
  'moneyIn.voucher.p41OngoingLifetimeAnnuityPayments':
    'P41-løbende udbetalinger fra livsvarig livrente',
  'moneyIn.voucher.p41OngoingStoppingAnnuityPayments':
    'P41-løbende udbetalinger fra ophørende livrente',
  'moneyIn.voucher.p41PaymentAgeType': 'P41-udbetalingsalderstype',
  'moneyIn.voucher.p41PaymentFrequency': 'P41-udbetalingsfrekvens',
  'moneyIn.voucher.p41PaymentInformation': 'P41-betalingsoplysninger',
  'moneyIn.voucher.p41PaymentSpecVoucherRef':
    'P41-reference til betalingsspecifikationsbilag',
  'moneyIn.voucher.p41PensionPALTax': 'P41-pensions-PAL-skat',
  'moneyIn.voucher.p41PensionPaymentInformation':
    'P41-pensionsbetalingsoplysninger',
  'moneyIn.voucher.p41PensionTransferDatas': 'P41-pensionsoverførselsdata',
  'moneyIn.voucher.p41TaxCode': 'P41-skattekode',
  'moneyIn.voucher.p41TaxPeriode': 'P41-skatteperiode',
  'moneyIn.voucher.p41Transfer': 'P41-overførsel',
  'moneyIn.voucher.pALTaxPayedOngoingAgeScheme_Bank':
    'Betalt PAL-skat, løbende aldersopsparing (bank)',
  'moneyIn.voucher.paidHoursInTimeSlot': 'Betalte timer i tidsintervallet',
  'moneyIn.voucher.palTax': 'PAL-skat',
  'moneyIn.voucher.palTax32Period': 'PAL-skatteperiode (§ 32)',
  'moneyIn.voucher.palTaxExemptionDate': 'Dato for PAL-skattefritagelse',
  'moneyIn.voucher.palTaxPeriod': 'PAL-skatteperiode',
  'moneyIn.voucher.palTaxPeriodPayed': 'Betalt PAL-skat for perioden',
  'moneyIn.voucher.palTaxPeriodUnusedNegative':
    'Uudnyttet negativ PAL-skat for perioden',
  'moneyIn.voucher.palTaxPeriodYear': 'PAL-skatteperiodens år',
  'moneyIn.voucher.panVar': 'PAN-variant',
  'moneyIn.voucher.parentPaymentId': 'Overordnet betaling-ID',
  'moneyIn.voucher.partialInterestAmount_Bank': 'Delvist rentebeløb (bank)',
  'moneyIn.voucher.partialPaymentTotal_Bank': 'Samlet delbetaling (bank)',
  'moneyIn.voucher.partialReceiver': 'Delvis modtager',
  'moneyIn.voucher.partialSender': 'Delvis afsender',
  'moneyIn.voucher.partialTransferAgeSchemeAmount':
    'Deloverførsel af aldersopsparing, beløb',
  'moneyIn.voucher.partialTransferAgeSchemeTaxFree':
    'Deloverførsel af skattefri aldersopsparing',
  'moneyIn.voucher.partialTransferAgeSchemeTaxfree':
    'Deloverførsel af skattefri aldersopsparing',
  'moneyIn.voucher.partialTransferAmount': 'Delvist overførselsbeløb',
  'moneyIn.voucher.partialTransferLifeTimeAnnuity':
    'Deloverførsel af livsvarig livrente',
  'moneyIn.voucher.partialTransferLifetimeAnnuity':
    'Deloverførsel af livsvarig livrente',
  'moneyIn.voucher.partialTransferTaxCode1': 'Deloverførsel, skattekode 1',
  'moneyIn.voucher.partialTransferTaxCode1Amount':
    'Deloverførselsbeløb, skattekode 1',
  'moneyIn.voucher.partialTransferTaxCode2': 'Deloverførsel, skattekode 2',
  'moneyIn.voucher.partialTransferTaxCode2Amount':
    'Deloverførselsbeløb, skattekode 2',
  'moneyIn.voucher.partialTransferTaxCode3': 'Deloverførsel, skattekode 3',
  'moneyIn.voucher.partialTransferTaxCode3Amount':
    'Deloverførselsbeløb, skattekode 3',
  'moneyIn.voucher.participant': 'Deltager',
  'moneyIn.voucher.participantId': 'Deltager-ID',
  'moneyIn.voucher.parttimePct': 'Deltidsprocent',
  'moneyIn.voucher.parttimePercentage': 'Deltidsprocent',
  'moneyIn.voucher.payInCash': 'Kontant betaling',
  'moneyIn.voucher.payableId': 'Udbetaling-ID',
  'moneyIn.voucher.payer': 'Betaler',
  'moneyIn.voucher.payerId': 'Betaler-ID',
  'moneyIn.voucher.payerLegalEntityId': 'Betalers juridiske enhed-ID',
  'moneyIn.voucher.payerRef': 'Betalerreference',
  'moneyIn.voucher.payingCompany': 'Betalende virksomhed',
  'moneyIn.voucher.payment': 'Ydelse',
  'moneyIn.voucher.paymentAge': 'Udbetalingsalder',
  'moneyIn.voucher.paymentBasis': 'Betalingsgrundlag',
  'moneyIn.voucher.paymentDate': 'Betalingsdato',
  'moneyIn.voucher.paymentEndDate': 'Udbetalingsslut',
  'moneyIn.voucher.paymentEntryRef': 'Betalingspostreference',
  'moneyIn.voucher.paymentFrequency': 'Udbetalingsfrekvens',
  'moneyIn.voucher.paymentId': 'Udbetalings-ID',
  'moneyIn.voucher.paymentInterest': 'Betalingsrente',
  'moneyIn.voucher.paymentMethod': 'Betalingsmetode',
  'moneyIn.voucher.paymentOrigin': 'Betalingens oprindelse',
  'moneyIn.voucher.paymentPeriodEnd': 'Betalingsperiodens slutdato',
  'moneyIn.voucher.paymentPeriodFrom': 'Betalingsperiode fra',
  'moneyIn.voucher.paymentPeriodStart': 'Betalingsperiodens startdato',
  'moneyIn.voucher.paymentPeriodTo': 'Betalingsperiode til',
  'moneyIn.voucher.paymentReceiverType': 'Betalingsmodtagertype',
  'moneyIn.voucher.paymentReferences': 'Betalingsreferencer',
  'moneyIn.voucher.paymentRemark': 'Betalingsbemærkning',
  'moneyIn.voucher.paymentSender': 'Betalingsafsender',
  'moneyIn.voucher.paymentSpecOrigin': 'Betalingsspecifikationens oprindelse',
  'moneyIn.voucher.paymentSpecVoucherRef':
    'Reference til betalingsspecifikationsbilag',
  'moneyIn.voucher.paymentStartDate': 'Udbetalingsstart',
  'moneyIn.voucher.paymentTotal': 'Samlet betaling',
  'moneyIn.voucher.paymentType': 'Udbetalingsform',
  'moneyIn.voucher.paymentWithoutInterest': 'Betaling uden renter',
  'moneyIn.voucher.paymentWithoutPALandInterest':
    'Betaling uden PAL-skat og renter',
  'moneyIn.voucher.pblLimit': 'PBL-grænse',
  'moneyIn.voucher.pekoInvoiceDetails': 'PEKO-fakturalinjer',
  'moneyIn.voucher.penaltyId': 'Gebyr-ID',
  'moneyIn.voucher.pensAlderKod': 'Pensionsalderskode',
  'moneyIn.voucher.pensBidragPct': 'Pensionsbidrag (%)',
  'moneyIn.voucher.pensBidragPctStartDto':
    'Startdato for pensionsbidragsprocent',
  'moneyIn.voucher.pensType': 'Pensionstype',
  'moneyIn.voucher.pensionAccountToTransfer': 'Aftalenummer',
  'moneyIn.voucher.pensionScheme': 'Pensionsordning',
  'moneyIn.voucher.pensionableSalary': 'Pensionsgivende løn',
  'moneyIn.voucher.percentLeave': 'Orlovsprocent',
  'moneyIn.voucher.percentage': 'Procent',
  'moneyIn.voucher.period': 'Periode',
  'moneyIn.voucher.periodEnd': 'Periodens slutdato',
  'moneyIn.voucher.periodFullSalaryLeave': 'Periode med fuld løn under orlov',
  'moneyIn.voucher.periodNonStructuralSalary': 'Periodens ikke-faste løn',
  'moneyIn.voucher.periodSalary': 'Periodens løn',
  'moneyIn.voucher.periodStart': 'Periodens startdato',
  'moneyIn.voucher.personDataValidationStatus':
    'Valideringsstatus for personoplysninger',
  'moneyIn.voucher.personId': 'Person-ID',
  'moneyIn.voucher.personRef': 'Personreference',
  'moneyIn.voucher.personSpecVouchersForRemoval':
    'Personspecifikationsbilag til fjernelse',
  'moneyIn.voucher.personnelNumber': 'Medarbejdernummer',
  'moneyIn.voucher.policyDescription': 'Policebeskrivelse',
  'moneyIn.voucher.policyHolder': 'Forsikringstager',
  'moneyIn.voucher.policyInternalTemplateId': 'Policens interne skabelon-ID',
  'moneyIn.voucher.policyKey': 'Police',
  'moneyIn.voucher.policyNumber': 'Policenummer',
  'moneyIn.voucher.policyToTransfer': 'Police til overførsel',
  'moneyIn.voucher.postingText': 'Posteringstekst',
  'moneyIn.voucher.postingType': 'Posteringstype',
  'moneyIn.voucher.premiumBase': 'Præmiegrundlag',
  'moneyIn.voucher.premiumBasis': 'Præmieberegningsgrundlag',
  'moneyIn.voucher.premiumEmployee': 'Medarbejderpræmie',
  'moneyIn.voucher.premiumFromDueDate': 'Præmie fra forfaldsdato',
  'moneyIn.voucher.premiumInvoiceDetail': 'Præmiefakturalinje',
  'moneyIn.voucher.premiumInvoiceDetails': 'Præmiefakturalinjer',
  'moneyIn.voucher.premiumTotal': 'Samlet præmie',
  'moneyIn.voucher.previousInvoiceIds': "Tidligere faktura-ID'er",
  'moneyIn.voucher.priority': 'Prioritet',
  'moneyIn.voucher.processId': 'Proces-ID',
  'moneyIn.voucher.processingPeriodStart': 'Behandlingsperiodens startdato',
  'moneyIn.voucher.providerCVR': 'Udbyders CVR-nummer',
  'moneyIn.voucher.publicLawAppointmentForIndefinitePeriod':
    'Tidsubegrænset offentligretlig ansættelse',
  'moneyIn.voucher.rawLine': 'Rå linje',
  'moneyIn.voucher.rec1Reserve1Txt': 'Record 1, reservefelt 1',
  'moneyIn.voucher.rec3Reserve1Txt': 'Record 3, reservefelt 1',
  'moneyIn.voucher.rec4Reserve1Txt': 'Record 4, reservefelt 1',
  'moneyIn.voucher.recTypeId': 'Recordtype-ID',
  'moneyIn.voucher.receiverId': 'Modtager-ID',
  'moneyIn.voucher.receiverPBSNumber': 'Modtagers PBS-nummer',
  'moneyIn.voucher.receivingAccount': 'Modtagerkonto',
  'moneyIn.voucher.receivingCompany': 'Modtagende selskab',
  'moneyIn.voucher.receivingCompanyId': 'Modtagende selskab-ID',
  'moneyIn.voucher.receivingCompanyType': 'Modtagende selskabstype',
  'moneyIn.voucher.receivingDate': 'Modtagelsesdato',
  'moneyIn.voucher.receivingFundId': 'Modtagende fonds-ID',
  'moneyIn.voucher.recipientAccountId': 'Modtagerkonto-ID',
  'moneyIn.voucher.recipientCustomerId': 'Modtagerkunde-ID',
  'moneyIn.voucher.recipientOwnDepartmentId': 'Modtagers egen afdeling-ID',
  'moneyIn.voucher.reconcileInfo': 'Afstemningsoplysninger',
  'moneyIn.voucher.reconcileNote': 'Afstem note',
  'moneyIn.voucher.reconcileValueDate': 'Afstemningsvalørdag',
  'moneyIn.voucher.reconciledPaymentDate': 'Afstemt betalingsdato',
  'moneyIn.voucher.recurring': 'Løbende',
  'moneyIn.voucher.reductionDueToForeignTax': 'Lempelse for udenlandsk skat',
  'moneyIn.voucher.reference': 'Reference',
  'moneyIn.voucher.regulationType': 'Reguleringstype',
  'moneyIn.voucher.relatedLegalEntityId': 'Tilknyttet juridisk enheds-ID',
  'moneyIn.voucher.relatedPersonId': 'Relateret person-ID',
  'moneyIn.voucher.relationshipId': 'Relations-ID',
  'moneyIn.voucher.relationshipNumber': 'Relationsnummer',
  'moneyIn.voucher.remark': 'Bemærkning',
  'moneyIn.voucher.remarkFreeText': 'Bemærkning i fritekst',
  'moneyIn.voucher.remunerationPeriod': 'Betalingsperiode',
  'moneyIn.voucher.remunerationPeriodMetrics': 'Lønperiodestatistik',
  'moneyIn.voucher.repurchase': 'Tilbagekøb',
  'moneyIn.voucher.repurchaseClause': 'Genkøbsklausul tekst',
  'moneyIn.voucher.repurchaseClauseText': 'Genkøbsklausul tekst',
  'moneyIn.voucher.requestDate': 'Dato for anmodning',
  'moneyIn.voucher.requestedDueDate': 'Anmodet forfaldsdato',
  'moneyIn.voucher.resignationDate': 'Opsigelsesdato',
  'moneyIn.voucher.responseDateTime': 'Svartidspunkt',
  'moneyIn.voucher.retrievalReqNbr': 'Nummer på informationsanmodning',
  'moneyIn.voucher.retrievedEmploymentTermsAmount':
    'Hentet beløb fra ansættelsesvilkår',
  'moneyIn.voucher.returnAutomatically': 'Returner automatisk',
  'moneyIn.voucher.returnInformation': 'Tilbagebetalingsoplysninger',
  'moneyIn.voucher.returnPaymentInfos': 'Oplysninger om returbetaling',
  'moneyIn.voucher.returnPaymentInvoiceId': 'Tilbagebetalingsfaktura-ID',
  'moneyIn.voucher.returnReason': 'Returårsag',
  'moneyIn.voucher.returnedPaymentPayableId':
    'Udbetalings-ID for returneret betaling',
  'moneyIn.voucher.reversalIndicator': 'Tilbageførselsindikator',
  'moneyIn.voucher.routingSource': 'Routingkilde',
  'moneyIn.voucher.routingTarget': 'Routingmål',
  'moneyIn.voucher.salary': 'Løn',
  'moneyIn.voucher.salaryDetails': 'Lønoplysninger',
  'moneyIn.voucher.salaryFromDate': 'Løn fra dato',
  'moneyIn.voucher.salaryInArrears': 'Bagudlønnet',
  'moneyIn.voucher.salaryInPeriod': 'Løn i perioden',
  'moneyIn.voucher.salaryInformation': 'Lønoplysninger',
  'moneyIn.voucher.salaryLastChangedDate': 'Dato for seneste lønændring',
  'moneyIn.voucher.salaryLevel': 'Lønniveau',
  'moneyIn.voucher.salaryPartTimePct': 'Deltidsprocent',
  'moneyIn.voucher.salaryPeriodCancelled': 'Lønperiode annulleret',
  'moneyIn.voucher.salaryPeriodEnd': 'Lønperiodeslut',
  'moneyIn.voucher.salaryPeriodStart': 'Lønperiodestart',
  'moneyIn.voucher.salaryToDate': 'Løn til dato',
  'moneyIn.voucher.salaryType': 'Løntype',
  'moneyIn.voucher.schemeDatas': 'Ordningsdata',
  'moneyIn.voucher.schemeId': 'Ordnings-ID',
  'moneyIn.voucher.schemeVariant': 'Ordningsvariant',
  'moneyIn.voucher.schemeWage': 'Ordningsløn',
  'moneyIn.voucher.sectionNumber': 'Sektionsnummer',
  'moneyIn.voucher.sector': 'Sektor',
  'moneyIn.voucher.sectors': 'Sektorer',
  'moneyIn.voucher.senderAccount': 'Afsenderkonto',
  'moneyIn.voucher.senderAccountNumber': 'Afsenders kontonummer',
  'moneyIn.voucher.senderCVR': 'Afsenders CVR-nummer',
  'moneyIn.voucher.senderCustomerRef': 'Afsenders kundereference',
  'moneyIn.voucher.seniorityFromDate': 'Anciennitetsdato',
  'moneyIn.voucher.sentDateTime': 'Afsendelsestidspunkt',
  'moneyIn.voucher.sequence': 'Sekvens',
  'moneyIn.voucher.sequenceNumber': 'Sekvensnummer',
  'moneyIn.voucher.settFkMedlemdsNr': 'Medlemsnummer (Sett FK)',
  'moneyIn.voucher.settFkMedlemsNr': 'Afregningsmedlemsnummer (FK)',
  'moneyIn.voucher.settleDate': 'Afregningsdato',
  'moneyIn.voucher.settlementFraction': 'Afregningsandel',
  'moneyIn.voucher.severity': 'Alvorlighedsgrad',
  'moneyIn.voucher.signingDate': 'Underskriftsdato',
  'moneyIn.voucher.skipFurtherAutoCorrection':
    'Spring yderligere automatisk korrektion over',
  'moneyIn.voucher.sourceRef': 'Kildereference',
  'moneyIn.voucher.sourceReference': 'Kildereference',
  'moneyIn.voucher.spec': 'Specifikation',
  'moneyIn.voucher.specialCircumstances': 'Særlige omstændigheder',
  'moneyIn.voucher.specialPaymentRules': 'Særlige betalingsregler',
  'moneyIn.voucher.specificationCreationDate':
    'Specifikationens oprettelsesdato',
  'moneyIn.voucher.specificationEndDate': 'Specifikationens slutdato',
  'moneyIn.voucher.specificationLineId': 'Specifikationslinje-ID',
  'moneyIn.voucher.specificationNumber': 'Specifikationsnummer',
  'moneyIn.voucher.specificationStartDate': 'Specifikationens startdato',
  'moneyIn.voucher.specifiedAmount': 'Specificeret beløb',
  'moneyIn.voucher.spouseIdentity': 'Ægtefællens identitet',
  'moneyIn.voucher.spousePension': 'Ægtefællepension',
  'moneyIn.voucher.spousePensionAmount': 'Ægtefælle beløb der skal afdrages',
  'moneyIn.voucher.spousePensionDate': 'Ægtefællepensionsdato',
  'moneyIn.voucher.spousePensionPeriod': 'Ægtefælle afdragsperiode',
  'moneyIn.voucher.stamp': 'Tidsstempel',
  'moneyIn.voucher.startDate': 'Startdato',
  'moneyIn.voucher.startDateIncomePeriod': 'Indkomstperiodens startdato',
  'moneyIn.voucher.stoppingPensionPBL15A': 'Ophørende pension (PBL § 15 A)',
  'moneyIn.voucher.subIssues': 'Underliggende problemer',
  'moneyIn.voucher.sumPaymentTaxCode1and2TransferYear':
    'Samlede betalinger, skattekode 1 og 2, overførselsår',
  'moneyIn.voucher.sumPaymentTaxfreeAgeSchemeTransferYear':
    'Samlede betalinger til skattefri aldersopsparing i overførselsåret',
  'moneyIn.voucher.sumReturnsAverageInterestRate':
    'Samlet afkast med gennemsnitsrente',
  'moneyIn.voucher.sumReturnsMarketInterestRate':
    'Samlet afkast med markedsrente',
  'moneyIn.voucher.sumReturnsOngoingAgeScheme_Bank':
    'Samlet afkast af løbende aldersopsparing (bank)',
  'moneyIn.voucher.sumReturnsTransferYear': 'Samlet afkast i overførselsåret',
  'moneyIn.voucher.sumReturnsTransferYearPension':
    'Samlet pensionsafkast i overførselsåret',
  'moneyIn.voucher.sumStopPaymentsAnnuityInstalment':
    'Samlede ophørende livrente- og rateudbetalinger',
  'moneyIn.voucher.sumTaxfreeSinglePayment':
    'Samlet skattefri engangsudbetaling',
  'moneyIn.voucher.summaryDate': 'Opgørelsesdato',
  'moneyIn.voucher.supplementalAmountEntity': 'Supplerende beløbsenhed',
  'moneyIn.voucher.supplierId': 'Leverandør-ID',
  'moneyIn.voucher.suspensionDate': 'Suspensionsdato',
  'moneyIn.voucher.suspensionReason': 'Suspensionsårsag',
  'moneyIn.voucher.systemCode': 'Systemkode',
  'moneyIn.voucher.table.otherDetails': 'Andre oplysninger',
  'moneyIn.voucher.table.value': 'Værdi',
  'moneyIn.voucher.targetId': 'Mål-ID',
  'moneyIn.voucher.taskNumber': 'Opgavenummer',
  'moneyIn.voucher.taxCode1ValuePayedToCustomer':
    'Beløb udbetalt til kunden, skattekode 1',
  'moneyIn.voucher.taxInformation': 'Skatteoplysninger',
  'moneyIn.voucher.telephoneNumber': 'Telefonnummer',
  'moneyIn.voucher.template': 'Skabelon',
  'moneyIn.voucher.tenantId': 'Tenant-ID',
  'moneyIn.voucher.terminalOpeMeNo': 'Terminaloperatørnummer',
  'moneyIn.voucher.timeSlotEndDate': 'Tidsintervallets slutdato',
  'moneyIn.voucher.timeSlotStartDate': 'Tidsintervallets startdato',
  'moneyIn.voucher.toDate': 'Til dato',
  'moneyIn.voucher.toDueDate': 'Til forfaldsdato',
  'moneyIn.voucher.totalAmount': 'Total beløb',
  'moneyIn.voucher.totalAmountInFile': 'Samlet beløb i fil',
  'moneyIn.voucher.totalContributionPercentage': 'Totalt bidrag i procent',
  'moneyIn.voucher.totalNoOfContributions': 'Samlet antal bidrag',
  'moneyIn.voucher.traceId': 'Sporings ID',
  'moneyIn.voucher.transTypeCode': 'Transaktionstypekode',
  'moneyIn.voucher.transactionType': 'Transaktionstype',
  'moneyIn.voucher.transactions': 'Transaktioner',
  'moneyIn.voucher.transactionsNo': 'Antal transaktioner',
  'moneyIn.voucher.transferAgeSchemeTaxFree':
    'Overførsel af skattefri aldersopsparing',
  'moneyIn.voucher.transferData': 'Overførselsdata',
  'moneyIn.voucher.transferDataNumber': 'Overførselsdatanummer',
  'moneyIn.voucher.transferDate': 'Overførselsdato',
  'moneyIn.voucher.transferOngoingInstalmentPension':
    'Ratepension under udbetaling',
  'moneyIn.voucher.transferStoppingOngoingAnnuity':
    'Overførsel af løbende ophørende livrente',
  'moneyIn.voucher.transferTaxCode1': 'Overførsel, skattekode 1',
  'moneyIn.voucher.transferTaxCode2': 'Overførsel, skattekode 2',
  'moneyIn.voucher.transferTaxCode3': 'Overførsel, skattekode 3',
  'moneyIn.voucher.transferredIn': 'Overført ind',
  'moneyIn.voucher.transferringFundId': 'Afgivende pensionskasse-ID',
  'moneyIn.voucher.twkInvoice': 'TWK-faktura',
  'moneyIn.voucher.txtRecvAcctStm': 'Tekst på modtagers kontoudtog',
  'moneyIn.voucher.typeOfPension': 'Pensionstype',
  'moneyIn.voucher.typeOfTransfer': 'Overførselstype',
  'moneyIn.voucher.unexpectedInvoicePaymentType':
    'Type af uventet fakturabetaling',
  'moneyIn.voucher.uniqueNtryRef': 'Unik postreference',
  'moneyIn.voucher.uniqueStmtId': 'Unikt kontoudtogs-ID',
  'moneyIn.voucher.unparseableRecord04': 'Record 04 kunne ikke fortolkes',
  'moneyIn.voucher.unparseableValues': 'Værdier kunne ikke fortolkes',
  'moneyIn.voucher.unrelatedPaymentType': 'Urelateret betalingsmetode',
  'moneyIn.voucher.unusedNegativePALOngoingAgeScheme_Bank':
    'Uudnyttet negativ PAL-skat, løbende aldersopsparing (bank)',
  'moneyIn.voucher.upaDeclarationType': 'UPA-indberetningstype',
  'moneyIn.voucher.upaIncomeRelation': 'UPA-indkomstforhold',
  'moneyIn.voucher.upaIncomeRelationVoucherRef':
    'Reference til UPA-indkomstforholdsbilag',
  'moneyIn.voucher.upaProcessingResult': 'UPA-behandlingsresultat',
  'moneyIn.voucher.upaSchemeId': 'UPA-ordnings-ID',
  'moneyIn.voucher.upaTimeSlotDeclarationType':
    'UPA-tidsintervalindberetningstype',
  'moneyIn.voucher.upaTimeSlotType': 'UPA-tidsintervaltype',
  'moneyIn.voucher.upaXmlSchemaVersion': 'UPA-XML-skemaversion',
  'moneyIn.voucher.upcomingReturnPaymentPostingId':
    'Kommende tilbagebetalingsposterings-ID',
  'moneyIn.voucher.usedDefaultEmployerAgreementPolicy':
    'Standardpolice for arbejdsgiveraftale anvendt',
  'moneyIn.voucher.usedSoftwarePackage': 'Anvendt softwarepakke',
  'moneyIn.voucher.userId': 'Bruger-ID',
  'moneyIn.voucher.usesProjectedData': 'Bruger fremskrevne data',
  'moneyIn.voucher.validationErrorIssues': 'Valideringsfejl',
  'moneyIn.voucher.validationResult': 'Valideringsresultat',
  'moneyIn.voucher.value79Before72': 'Værdi 79 før 72',
  'moneyIn.voucher.value79From72To79': 'Værdi 79 fra 72 til 79',
  'moneyIn.voucher.value82': 'Værdi 82',
  'moneyIn.voucher.valueFromPayload': 'Værdi fra indholdsdata',
  'moneyIn.voucher.valueTransferId': 'Værdioverførsel-ID',
  'moneyIn.voucher.valueTransferStatement': 'Værdioverførselsopgørelse',
  'moneyIn.voucher.valueTransferType': 'Værdioverførselstype',
  'moneyIn.voucher.valueTransfered': 'Overført værdi',
  'moneyIn.voucher.voluntaryContributionPlacement':
    'Placering af frivilligt bidrag',
  'moneyIn.voucher.voluntaryContributionPolicyId':
    'Police-ID for frivilligt bidrag',
  'moneyIn.voucher.voluntaryContributionType': 'Frivillig bidragstype',
  'moneyIn.voucher.voucherFieldName': 'Bilagsfeltnavn',
  'moneyIn.voucher.voucherVersionSequenceNumber':
    'Bilagsversionens sekvensnummer',
  'moneyIn.voucher.wageFromOvertime': 'Overtidsløn',
  'moneyIn.voucher.wageTaxTableCode': 'Lønskattetabelkode',
  'moneyIn.voucher.wagesLBPH': 'LBPH-løn',
  'moneyIn.voucher.wagesSV': 'SV-løn',
  'moneyIn.voucher.wagesTaxedSpecialRenumerationTable':
    'Løn beskattet efter særlig vederlagstabel',
  'moneyIn.voucher.warningCodes': 'Advarselskoder',
  'moneyIn.voucher.warnings': 'Advarsler',
  'moneyIn.voucher.widowIdentity': 'Enkens identitet',
  'moneyIn.voucher.withdrawPaymentCommandId':
    'Kommando ID for tilbagetrækning af betaling',
  'moneyIn.voucher.withdrawalDate': 'Tilbagetrækningsdato',
  'moneyIn.voucher.withdrawnPenaltyId': 'Tilbagetrukket gebyr-ID',
  'moneyIn.voucher.withholdPALTax': 'Tilbagehold PAL-skat',
  'moneyIn.voucher.withholdPALTaxTransferYear':
    'Tilbagehold PAL-skat i overførselsåret',
  'moneyIn.voucher.workHours': 'Arbejdstimer',
  'moneyIn.voucher.workHoursInPeriod': 'Arbejdstimer i perioden',
  'moneyIn.voucher.workflowRef': 'Workflowreference',
  'moneyIn.voucher.writeOffCategory': 'Afskrivningskategori',
  'moneyIn.voucher.writeOffType': 'Afskrivningstype',
  'moneyIn.voucher.yearOldestUnusedPALTax': 'År for ældste uudnyttede PAL-skat',
}
